import images from 'assets/images/images'
import CountdownTimer from 'components/CountdownTimer'
import Button from 'components/form-elements/buttons/Button'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useToast from 'hooks/useToast';
import { stages } from 'utils/Constants'
import { setTimer } from 'redux/register/registerSlice'
import { useRequest } from 'hooks/useRequest'
import LoaderTwo from 'pages/LoaderTwo'
import useTranslate from 'hooks/useTranslate'
import VerificationInput from 'react-verification-input'

const StageCode = ({setRegisterState}) => {

  const [timerFinish, setTimerFinish] = useState()
  const [codeData, setCodeData] = useState([])
  const { showToast } = useToast()
  const [request,loading] = useRequest()
  const dispatch = useDispatch()
  const {t} = useTranslate()

  const [timerExpired, setTimerExpired] = useState(false);
  const { register } = useSelector((state) => state)



  const handleTimeout = () => {
    setTimerExpired(true);
  };

  console.log(timerExpired  , "timerExpired");

  useEffect(() => {
    if (register.registerTimer) {
      showToast("Süre Doldu!", 'error')
      setTimerFinish(register.registerTimer)
    } else {
      setTimerFinish(false)
      dispatch(setTimer(false))
    }
  }, [register]);

  const handleFinish = () => {
    if (!timerFinish) {
      request('/InternalAuth/VerifyPhone', {
        method: 'POST',
        params: {
          dataId: register.registerDataCode,
          code: codeData.toString().replace(/,/g, ""),
        },

      }).then((res) => {
        if (res.data) {
          if (res.data.metadata) {
            showToast(res.data.metadata.message, 'error')
          }
          else if (res.data.ok == true) {
            setRegisterState(stages.STAGE_NEWLOGIN)
          }
        }
      })
    }
    else {
      request('/InternalAuth/ResendVerifyPhoneCode', {
        method: 'POST',
        params: {
          dataId: register.registerDataCode,
        },

      }).then((res) => {
        if (res.data) {
          setTimerFinish(false)
          showToast("Kod Tekrar Gönderildi..", 'success')
        }
      })
    }
  }
 


  return (
    <div className='register-container'>
       <LoaderTwo isDataLoading={loading} />
       <div className='register-container-stage3Img'>
        <img src={images.phone2} alt="" />
       </div>
        <div className='register-container-stage3Text'>{t('phoneCodeText',{phone:`********${register?.registerData?.phone?.slice(-2)}`})}</div>
        <VerificationInput
        validChars="0-9" 
        autoFocus={true}
        inputProps={{ inputMode: "numeric" }}
        length={8}
        placeholder=''
        onChange={(e) =>{
          setCodeData(e)
        }}
        value={codeData}
          classNames={{
            container: "register-container-code",
            character: "character",
            characterInactive: "character--inactive",
            characterSelected: "character--selected",
          }}
        />
        <div className='register-container-timer'>Süre:  <CountdownTimer minutes={5} seconds={Number(`00`)} onTimeout={handleTimeout} /></div>
        <div className='register-container-btnGroup stage3-btn-group'>
           <Button onClick={() => setRegisterState(prev => prev - 1)} className={"stageTwoBtnWhite"} icon={images.arrow} text={""}/>
           <Button onClick={handleFinish} className={"stageTwoBtnRed"}  icon={''} text={t('continue')}/>
         </div>    
    </div>
  )
}

export default StageCode